import { fetchApi } from '../utils/helpers';
import constants from '../constants';

const { FETCH_NATIONS_REQUEST, FETCH_NATIONS_SUCCESS, FETCH_NATIONS_FAILURE } = constants;

/**
 * Fetch nations
 */
export const fetchNationsSuccess = data => ({
  type: FETCH_NATIONS_SUCCESS,
  payload: {
    nations: data.nations,
  },
});

export const fetchNationsFailure = () => ({
  type: FETCH_NATIONS_FAILURE,
});

export const fetchNationsRequest = () => ({
  type: FETCH_NATIONS_REQUEST,
});

export const fetchNations = () => dispatch => {
  dispatch(fetchNationsRequest());

  return fetchApi({
    path: '/entries/Nations',
    method: 'get',
    dispatch,
    cb: fetchNationsSuccess,
    fb: fetchNationsFailure,
  });
};



// WEBPACK FOOTER //
// ./src/actions/nations.js